<template>
    <div v-if="currentCommsPayoutSummary.recruitment_payout_details.length > 0">
        <div>Recruitment Payout</div>
        <table class="table table-bordered" width="50%" >
            <thead>
                <tr>
                    <th class="bg-dark text-white py-2">#</th>
                    <th class="bg-dark text-white py-2">User</th>
                    <th class="bg-dark text-white py-2">Payout Level</th>
                    <th class="bg-dark text-white py-2">Total Revenue Point</th>
                    <th class="bg-dark text-white py-2">Payout <br>Percentage <br>(%)</th>
                    <th class="bg-dark text-white py-2" width="10px">Payout <br>Revenue Point</th>
                    <!-- <th class="bg-dark text-white py-1" width="200px">Manager Approval Status</th>
                    <th class="bg-dark text-white py-1" width="200px">Finance Approval Status</th>
                    <th class="bg-dark text-white py-1" width="200px">CEO Approval Status</th> -->
                </tr>
            </thead>
            <tbody>
                <template>
                    <tr v-for="(recruitment_payout_detail, index) in currentCommsPayoutSummary.recruitment_payout_details" :key="index">
                    <td class="py-2">{{ index+1 }}</td>
                    <td class="py-2">{{ recruitment_payout_detail.user.name }}</td>
                    <td class="py-2">{{ recruitment_payout_detail.payout_level_code }}</td>
                    <td class="py-2">RM {{ recruitment_payout_detail.total_revenue_point | moneyFormatter }}</td>
                    <td class="py-2">{{ recruitment_payout_detail.payout_percentage }}</td>
                    <td class="py-2">RM {{ recruitment_payout_detail.payout_revenue_point | moneyFormatter }}</td>
                    <!-- <template v-if="decide_mode">
                        <td class="py-1">
                            <el-select
                                v-model="recruitment_payout_detail.manager_approval_status" :disabled="permission.admin === false ? !permission.acceptor : !permission.admin"
                            >
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                />
                            </el-select>
                        </td>
                        <td class="py-1">
                            <el-select
                                v-model="recruitment_payout_detail.finance_approval_status" value-key="label" :disabled="permission.admin === false ? !permission.reviewer : !permission.admin"
                            >
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                />
                            </el-select>
                        </td>
                        <td class="py-1">
                            <el-select
                                v-model="recruitment_payout_detail.ceo_approval_status" :disabled="permission.admin === false ? !permission.approver : !permission.admin"
                            >
                                <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                />
                            </el-select>
                        </td>
                    </template>
                    <template v-else>
                        <td class="py-1">{{ recruitment_payout_detail.manager_approval_status_name }}</td>
                        <td class="py-1">{{ recruitment_payout_detail.finance_approval_status_name }}</td>
                        <td class="py-1">{{ recruitment_payout_detail.ceo_approval_status_name }}</td>
                    </template> -->
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'

export default {
  props: ['currentCommsPayoutSummary','decide_mode', 'permission', 'options'],
  components: {
        [Select.name]: Select,
        [Option.name]: Option,
  }
}
</script>